var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bottom desktop" }, [
    _c("div", { staticClass: "content-max-width flex" }, [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.headerIsSticky,
            expression: "headerIsSticky"
          }
        ],
        staticClass: "sticky-logo",
        attrs: { src: "/images/logo-mark.svg", alt: "Habit Health" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wrap" }, [
        _c(
          "div",
          { staticClass: "flex" },
          _vm._l(_vm.links, function(link) {
            return _c(
              "div",
              {
                key: link.id,
                staticClass: "parent flex",
                on: {
                  mouseover: function($event) {
                    _vm.showingMenu = link.id
                  },
                  mouseleave: function($event) {
                    _vm.showingMenu = null
                  }
                }
              },
              [
                _c("a", { staticClass: "parent-link" }, [
                  _c("h6", { staticClass: "flex" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(link.title) +
                        "\n                            "
                    ),
                    link.type === "Dropdown"
                      ? _c("span", { staticClass: "icon icon-angle-down" })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(link.alt_text))])
                ]),
                _vm._v(" "),
                _vm.showingMenu == link.id && link.type === "Dropdown"
                  ? _c("div", { staticClass: "megamenu" }, [
                      _c(
                        "div",
                        { staticClass: "content-max-width" },
                        [
                          link.heading
                            ? _c("p", { staticClass: "lead" }, [
                                _vm._v(_vm._s(link.heading))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "slick",
                            {
                              ref: "menu-slick-" + link.id,
                              refInFor: true,
                              staticClass: "menu-slider",
                              class: "menu-" + link.id,
                              attrs: {
                                options: {
                                  arrows: true,
                                  slidesToScroll: 1,
                                  slidesToShow: 4,
                                  infinite: false,
                                  responsive: [
                                    {
                                      breakpoint: 1350,
                                      settings: { arrows: false }
                                    },
                                    {
                                      breakpoint: 1024,
                                      settings: { slidesToShow: 4 }
                                    },
                                    {
                                      breakpoint: 850,
                                      settings: { slidesToShow: 3 }
                                    },
                                    {
                                      breakpoint: 350,
                                      settings: { slidesToShow: 2 }
                                    }
                                  ]
                                }
                              }
                            },
                            _vm._l(link.children, function(childLink) {
                              return _c(
                                "div",
                                {
                                  key: childLink.id,
                                  staticClass: "link-group"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        padding: "0"
                                      },
                                      attrs: { href: childLink.url }
                                    },
                                    [
                                      _c("h6", [
                                        _vm._v(_vm._s(childLink.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(childLink.alt_text))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  childLink.children.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "childLinks" },
                                        [
                                          _vm._l(childLink.children, function(
                                            grandChildLink
                                          ) {
                                            return _c(
                                              "a",
                                              {
                                                key: grandChildLink.id,
                                                attrs: {
                                                  href: grandChildLink.url,
                                                  target: grandChildLink.is_external
                                                    ? "blank"
                                                    : null
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(grandChildLink.title)
                                                )
                                              ]
                                            )
                                          }),
                                          _vm._v(" "),
                                          childLink.view_all.length > 0
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "all",
                                                  attrs: { href: childLink.url }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(childLink.view_all)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4149e921", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4149e921","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/SubHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4149e921","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/SubHeader.vue
// module chunks = 0